
import axios from 'axios'

export function sendReportinApiOrderUpdate(orderId,updateObject){
  axios.post('http://54.69.78.54:8080/PrintBReporting/webresources/orders/updateOrder', {
   // axios.post('http://localhost:8080/PrintBReporting/webresources/orders/updateOrder', {
        apiKey: 'xvzxvxvv',
        orderId:orderId,
        updateObject: updateObject
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
}

export function sendNewOrder(order){
  axios.post('http://54.69.78.54:8080/PrintBReporting/webresources/orders/saveOrder', {
        apiKey: 'dasdfasf',
        order: order
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Reporting/ReportingUtils.js